import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import Clients from "pages/Clients";
import ClientsDetail from "pages/Clients/detail";
import ClientsSubscription from "pages/Clients/subscription";
import ClientsTicket from "pages/Clients/ticket";
import ClientsMessages from "pages/Clients/messages";
import ClientInbox from "pages/Clients/clientInbox";
import UserProfile from "../pages/Authentication/user-profile";
import Teams from "pages/Teams";
import Billings from "pages/Billings";
import InvoiceDetail from "pages/Billings/invoice-detail";
import AdminSubscriptionPlans from "pages/subscription-plans";
import Logs from "pages/Logs";
import LogDetail from "pages/Logs/detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";


//Seting Pages

import ContactLevel from "pages/settings/contact-level";
import ContactStatus from "pages/settings/contact-status";
import ContactType from "pages/settings/contact-type";
import LeadSource from "pages/settings/lead-source";
import LeadStatus from "pages/settings/lead-status";
import LeadType from "pages/settings/lead-type";
import LeadStage from "pages/settings/lead-stage";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/clients", component: <Clients /> },
  { path: "/client/:id", component: <ClientsDetail /> },
  { path: "/client/subscription", component: <ClientsSubscription /> },
  { path: "/client/support-ticket", component: <ClientsTicket /> },
  { path: "/client/messages", component: <ClientsMessages /> },
  { path: "/client/emails", component: <ClientInbox /> },
  { path: "/teams", component: <Teams /> },
  { path: "/billing", component: <Billings /> },
  { path: "/invoice-detail", component: <InvoiceDetail /> },
  { path: "/subscription-plans", component: <AdminSubscriptionPlans /> },
  {path: "/logs-audits", component: <Logs />},
  {path: "/logs/detail", component: <LogDetail />},
  { path: "/setting/contact-level", component: <ContactLevel /> },
  { path: "/setting/contact-status", component: <ContactStatus /> },
  { path: "/setting/contact-type", component: <ContactType /> },
  { path: "/setting/lead-source", component: <LeadSource /> },
  { path: "/setting/lead-status", component: <LeadStatus /> },
  { path: "/setting/lead-type", component: <LeadType /> },
  { path: "/setting/lead-stage", component: <LeadStage /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
